document.getElementById('reset-form').addEventListener('submit', function(e) {
    document.getElementById('message-container').style.display = 'block';
});

$(window).on('load', function() {
    $('#page-content').show();
});
